const attrs = [
  {
    fill: "rgb(255, 204, 204)"
  },
  {
    fill: "rgb(242, 115, 115)"
  }
];

export const PDF = [
  {
    icon: {
      paths: [
        "M187.733 682.667v-307.2c0-18.851 15.282-34.133 34.133-34.133v0h580.267v-290.133c0-18.851-15.2" +
          "82-34.133-34.133-34.133v0h-529.067v170.667c0 18.851-15.282 34.133-34.133 34.133v0h-187.733v75" +
          "0.933c-0 18.851 15.282 34.133 34.133 34.133v0h716.8c18.851 0 34.133-15.282 34.133-34.133v0-256h" +
          "-580.267c-18.851 0-34.133-15.282-34.133-34.133v0zM187.733 682.667z",
        "M870.4 324.267h-51.2v-273.067c0-28.277-22.923-51.2-51.2-51.2v0h-529.067c-0.37 0-0.654 0.171-1.02" +
          "4 0.199-1.488 0.102-2.873 0.375-4.19 0.802l0.122-0.034c-0.657 0.168-1.198 0.343-1.724 0.547l0.10" +
          "2-0.035c-1.873 0.783-3.483 1.818-4.878 3.084l0.014-0.012-221.867 204.8c-1.496 1.429-2.72 3.126-3" +
          ".598 5.018l-0.043 0.102c-0.212 0.451-0.434 1.016-0.623 1.596l-0.031 0.111c-0.533 1.407-0.89 3.03" +
          "5-0.993 4.732l-0.002 0.047c0.028 0.341-0.199 0.683-0.199 0.91v750.933c0 28.277 22.923 51.2 51.2 " +
          "51.2v0h716.8c28.277 0 51.2-22.923 51.2-51.2v0-238.933h51.2c28.277 0 51.2-22.923 51.2-51.2v0-307." +
          "2c0-28.277-22.923-51.2-51.2-51.2h0zM221.867 56.064v131.669c0 9.426-7.641 17.067-17.067 17.067v0" +
          "h-144.071zM785.067 972.8c0 9.426-7.641 17.067-17.067 17.067v0h-716.8c-9.426 0-17.067-7.641-17.06" +
          "7-17.067v0-733.867h170.667c28.277 0 51.2-22.923 51.2-51.2v-153.6h512c9.426 0 17.067 7.641 17.067" +
          " 17.067v-0 273.067h-563.2c-28.277 0-51.2 22.923-51.2 51.2h-0v307.2c0 28.277 22.923 51.2 51.2 51." +
          "2h563.2zM887.467 682.667c0 9.426-7.641 17.067-17.067 17.067v0h-648.533c-9.426 0-17.067-7.641-17." +
          "067-17.067v0-307.2c0-9.426 7.641-17.067 17.067-17.067v0h648.533c9.426 0 17.067 7.641 17.067 17.0" +
          "67v0zM887.467 682.667z"
      ],
      attrs,
      width: 922,
      isMulticolor: true,
      isMulticolor2: false,
      grid: 0,
      tags: ["PDF"],
      colorPermutations: {
        "1161807012002551601226191431242115115124723618812552042041": [
          {
            f: 5
          },
          {
            f: 2
          }
        ]
      }
    },
    attrs,
    properties: {
      order: 9,
      id: 0,
      name: "PDF",
      prevSize: 32
    },
    setIdx: 0,
    setId: 6,
    iconIdx: 2
  },
  {
    icon: {
      paths: [
        "M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91." +
          "842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.9" +
          "22 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206" +
          ".294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-1" +
          "41.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
      ],
      tags: ["search", "magnifier", "magnifying-glass", "inspect", "find"],
      defaultCode: 59782,
      grid: 16,
      attrs: []
    },
    attrs: [],
    properties: {
      ligatures: "search, magnifier",
      name: "search",
      order: 3,
      id: 135,
      prevSize: 32
    },
    setIdx: 5,
    setId: 1,
    iconIdx: 134
  }
];
